/*
 * Copyright (c) Schrocken Inc.
 * Author: Ravi Teja
 * File Description: Reducer file for authentication
 */

import {
  USERS_DETAILS,
  PCMP_COLLABORATORS,
  PCMP_ROLES,
  ADD_PCMP_USER,
  REMOVE_PCMP_USER,
  SEND_INVITES,
  USER_DEACTIVATION,
  FETCH_WAREHOUSES,
} from '../../actions/types';

const initialState = {};

export default function (state = initialState, action) {
  switch (action.type) {
    case USERS_DETAILS:
      return {
        ...state,
        usersData: action.payload,
      };
    case PCMP_COLLABORATORS:
      return {
        ...state,
        collaborators: action.payload,
        addedUser: {},
        removedUser: {},
        invitedUsers: {},
      };
    case PCMP_ROLES:
      return {
        ...state,
        roles: action.payload,
        addedUser: {},
        removedUser: {},
        invitedUsers: {},
      };
    case ADD_PCMP_USER:
      return {
        ...state,
        addedUser: action.payload,
      };
    case REMOVE_PCMP_USER:
      return {
        ...state,
        removedUser: action.payload,
      };
    case SEND_INVITES:
      return {
        ...state,
        invitedUsers: action.payload,
      };
    case USER_DEACTIVATION:
      return {
        ...state,
        deactivatedUser: action.payload,
      };
    case FETCH_WAREHOUSES:
      return {
        ...state,
        warehousesList: action.payload,
      };
    default:
      return state;
  }
}
